"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Icon = ({ type, variant }) => {
    return (0, jsx_runtime_1.jsx)("i", { className: `bi ${type} ${variant ? 'text-' + variant : ''}` });
};
exports.Icon = Icon;
